// extracted by mini-css-extract-plugin
export default {"container":"container--aae03bbe7ef266e9ae7d"};